<template>
  <div class="pc-sidebar-container" :style="sidebarContainer" :class="{ asideIsClose }">
    <aside :style="sidebarContainer" class="pc-menu-wrapper" style="box-shadow: rgba(0, 0, 0, 0.1) 6px 0px 16px">
      <!--dx  logo增加下划线 -dx_border-botton :style="{backgroundImage : sideBarBackgroundImg}"-->
      <!-- <div class="pc-sidebar-image" :style="thema=='blue'?'':'background-image: url(static/img/sidebar-pc2.jpg);'"></div> -->
      <div class="pc-sidebar-image" :style="thema == 'blue' ? '' : `background-image: url('${$store.state.core.pc2.sideBarImg}')`">
        <!-- <div class="pc-sidebar-image" :style="thema=='blue'?'':`background-image: url('static/img/sidebar-pc2.jpg')`" > -->
      </div>
      <div class="pc-logo" :style="{ sidebarContainer, backgroundImage: `url(${$store.state.core.logoUrl})` }" @click="onToggleMenu">
        <div class="system-name" :style="thema == 'blue' ? 'color:#445974' : 'color: #fff;'">{{ systemName }}</div>
      </div>
      <div class="pc-border-bottom pc-border" style=""></div>
      <div class="menu-scroll fx__scroll_box" :style="{ height: menuScroll }">
        <Menu ref="menu" class="pc-menu-content" :style="{ menuStyle }" :accordion="true" :active-name="currentActive" :open-names="defaultOpeneds" @on-select="onSelect" @on-open-change="onMenuOpenAndClose">
          <template v-for="menu of menuSingleArr">
            <MenuItem :name="menu.name" class="pc-menu-item" :class="menu.name" :key="menu.name" v-if="menu.name != 'core-modulesNav'">
            <Tooltip :content="menu.text" :transfer="true" placement="right" :disabled="!asideIsClose" popper-class="puptip">
              <Badge :count="asideIsClose ?  $store.state.notify.moduleNoticeNum[menu.name] : 0">
                <svg-icon :iconClass="menu.svg" v-if="menu.svg" class="pc-item-icon"></svg-icon>
                <span class="pc-item-icon" v-else><i :class="menu.icon ? menu.icon : 'fa-flag'" class="fa fa-lg"></i></span>
                <!-- <span  class="pc-item-icon word_icon" v-else>{{(menu.text).charAt(0)}}</span> -->
                <span class="pc-item-title item-title" v-show="!asideIsClose">{{ menu.text }}</span>
              </Badge>
            </Tooltip>
            <Badge v-show="!asideIsClose" :count="$store.state.notify.moduleNoticeNum[menu.name]"></Badge>
            </MenuItem>
          </template>
        </Menu>
      </div>
      <div class="pc-border-bottom"></div>
      <!-- 分割线 -->
      <div class="modulesNav">
        <template v-for="(item, index) in menuNavArr">
          <div class="d-flex ai-center" :key="index" @click="onSelect11(index)" :class="['item', currentActive === `core-modulesNav${index}` ? 'active' : '']" v-if="item.name == 'core-modulesNav'">
            <Tooltip :content="item.text" placement="right" :disabled="!asideIsClose" popper-class="puptip">
              <!-- <svg-icon v-if="item.icon" :iconClass="item.icon" class="pc-item-icon"></svg-icon>
            <Icon v-else type="md-apps" size="24" /> -->
              <svg-icon :iconClass="item.svg" v-if="item.svg" class="pc-item-icon"></svg-icon>
              <span class="pc-item-icon" v-else><i :class="item.icon ? item.icon : 'fa-bars'" class="fa fa-lg"></i></span>
              <span class="pc-item-title item-title" v-show="!asideIsClose">{{ item.text }}</span>
            </Tooltip>
          </div>
        </template>
      </div>
    </aside>
    <div class="pc-sidebar-btn" :style="{'background-color':thema == 'blue' ?'rgba(106, 157, 204, 0.2)': 'rgba(75, 170, 78,0.2)',}" @click="onToggleMenu">
      <span class="fa fa-angle-right  fx-color-brand" :style="{'transition': 'transform 0.3s','transform': isCollapse?'':'rotate(180deg)'}"></span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 58,
    },
    backgroundColor: {
      type: String,
      default: "#2C2E48",
    },
    color: {
      type: String,
      default: "#b9bbbe",
    },
    activeColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
      isCollapse: true,
      asideIsClose: true,
      systemName: this.$store.state.core.headline || this.$app.ProjSetting.title, //从配置里取title
      menuStyle: {
        color: this.color,
      },
      svgStyle: {
        fill: this.color,
      },
      currentActive: "",
      defaultOpeneds: [],
      openedMenuIndex: [],
      openLocked: false,
      // sideBarBackgroundImg: `url(${require("../../../assets/images/sidebar-1.jpg")})`,
      sidebarContainer: {
        width: this.width + "px",
      },
      // menuNavArr: [], //有children的菜单
      // menus: [] //没有children的菜单
      menus: this.$app.menus,
      menuScroll: "",
    }
  },
  computed: {
    getNum() {
      let noticeNum = this.$store.getters["notify/getRouteNum"]
      console.log(this.$store.getters)

      if (noticeNum) return (name) => noticeNum(name)
      else return () => 0
    },
    thema() {
      return this.$store.state.core.thema
    },
    //无子菜单
    menuSingleArr() {
      let _this = this
      // console.log("menus111111111111111",this.menus)
      let _memus = _this.menus.filter((item) => {
        return !(item.children && item.children.length > 0)
      })
      return _memus.concat(_this.$store.state.core.menuStore.Userding)
    },
    //有子菜单
    menuNavArr() {
      return this.menus.filter((item) => {
        // return item.children && item.children.length > 0&&item.name=='core-modulesNav';
        if (item.children && item.children.length > 0) {
          //关键代码行,保证如果菜单提级别的时候，能够继续完美适应成为一个大菜单模块
          item.name = "core-modulesNav"
          return true
        }
        return false
      })
    },
    // isHasModuleNav() {
    //   let item = this.$app.menus.find((p) => p.name == "core-modulesNav");
    //   return item ? true : false;
    // },
    // menus() {
    //   return this.$app.menus;
    // }
  },
  watch: {
    $route: {
      handler: function (to, from) {
        let _this = this

        let name = to.matched[1].name
        // const p_obj = findRoute(_this.menus, null, name);
        // const indexes = [];
        // if (p_obj && p_obj.parent) indexes.push(p_obj.parent.name);

        // _this.defaultOpeneds = indexes;
        // _this.openedMenuIndex = indexes;

        if (_this.$route.name === "core-modulesNav") {
          _this.currentActive = `core-modulesNav${_this.$route.params.index}`
        } else {
          _this.currentActive = name
        }
      },
      immediate: true,
    },
  },
  methods: {
    onMenuOpenAndClose(openids) {
      this.openedMenuIndex = openids
    },
    onMouseAction() {
      let _this = this
      if (!_this.openLocked) {
        _this.onToggleMenu(false)
      } else {
        _this.$store.commit("core/setMenuWidth", "260px")
      }
    },
    onSelect(name) {
      this.$app.routeMenuTo(name)
    },
    onSelect11(para) {
      let activePathName = `core-modulesNav${para}`
      this.currentActive = activePathName
      this.$router.push({ path: "/" + activePathName })
      console.log("选择路由2")
    },
    onToggleMenu(lock = true) {
      let _this = this
      _this.isCollapse = !_this.isCollapse
      if (lock !== false) {
        _this.openLocked = !_this.isCollapse
      }
      //菜单展开
      if (!_this.isCollapse) {
        _this.sidebarContainer.width = "260px"
        _this.defaultOpeneds = [..._this.openedMenuIndex]
        _this.asideIsClose = false
        _this.$store.commit("core/setMenuWidth", "260px")
      }
      //菜单收起
      else {
        _this.sidebarContainer.width = _this.width + "px"
        _this.defaultOpeneds = []
        _this.asideIsClose = true
        _this.$store.commit("core/setMenuWidth", _this.width + "px")
      }
      _this.$nextTick(() => {
        _this.$refs.menu.updateOpened()
      })
    },
  },
  mounted() {
    // this.menus = this.$app.menus.filter(item => {
    //   if (item.children === undefined) return true;
    //   if (item.children.length < 1) return false;
    //   this.menuNavArr.push(item);
    // });

    this.$nextTick(() => {
      if (window.$app.uiStyle.meta.leftnav_expand) this.onToggleMenu()
      this.menuScroll = `calc(100% - ${this.menuNavArr.length * 47.99}px)`
    })
  },
}
</script>
<style lang="scss" scoped>
//修改iview侧边栏菜单样式
.pc-menu-wrapper {
  .ivu-menu-item {
    margin: 0 10px;
    height: 49px; //权宜之计
  }

  .ivu-menu-submenu-title {
    margin: 0 10px;
  }

  .ivu-menu li {
    .ivu-menu {
      .pc-item-icon {
        justify-content: center;
        display: flex;
        text-align: center;
        left: 34px;
        & + .pc-item-title {
          margin-left: 40px;
        }
      }
    }
  }
  .ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
    color: #fff;
    border-radius: 4px;
    background-color: #4caf50;
  }
}
.pc-menu-wrapper {
  > ul {
    > li {
      .pc-item-icon {
        & + .pc-item-title {
          margin-left: 14px;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
// fiexd布局定位在左侧
.pc-sidebar-container {
  -moz-user-select: none; /* Firefox私有属性 */
  -webkit-user-select: none; /* WebKit内核私有属性 */
  -ms-user-select: none; /* IE私有属性(IE10及以后) */
  -khtml-user-select: none; /* KHTML内核私有属性 */
  -o-user-select: none; /* Opera私有属性 */
  user-select: none; /* CSS3属性 */
  position: fixed;
  height: calc(100%);
  top: 0;
  transition: all 0.3s ease;
  z-index: 99;
  color: #b9bbbe;
  .pc-sidebar-image {
    transition: all 0.3s ease;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    z-index: -1;
  }
  // absolute脱离文档流
  .pc-logo {
    position: absolute;
    width: 100%;
    top: 0;
    transition: all 0.3s ease;
    cursor: pointer;
    overflow: hidden;
    height: 70px;
    z-index: 1;
    background-repeat: no-repeat;
    background-position: 10px;
    display: flex;
    align-items: center;
    .system-name {
      user-select: none;
      position: absolute;
      font-weight: 600;
      width: 240px;
      padding-left: 60px;
      padding-right: 10px;
      font-size: 17px;
      color: #fff;
      opacity: 1;
      transition: opacity 0.3s ease;
      overflow: hidden;
      text-align: center;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  // absolute脱离文档流
  .pc-menu-wrapper {
    position: absolute;
    display: flex;
    width: 100%;
    height: calc(100%);
    flex-direction: column;
    transition: all 0.3s ease;
    padding-top: 70px;
    padding-bottom: 50px;
    .menu-scroll {
      &::-webkit-scrollbar {
        width: 5px;
        height: 10px;
      }
      &::-webkit-scrollbar-thumb {
        background: #606870;
        border-radius: 10px;
        &:hover {
          background: #606870;
        }
      }

      &::-webkit-scrollbar-corner {
        background: transparent;
      }
    }
    .pc-menu-content {
      background-color: transparent;
      width: 100% !important;
      position: relative;
      transition: all 0.3s ease;
      position: relative;
    }
    .pc-menu-item {
      display: flex;
      justify-content: space-between;
      white-space: nowrap;
    }
    .pc-menu-trigger {
      display: flex;
      height: 50px;
      flex-shrink: 0;
      padding-left: 24px;
      align-items: center;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
    }
    .ivu-menu-submenu {
      .ivu-menu {
        color: inherit;
      }
    }

    .modulesNavSelected {
      color: #fff !important;
      background-color: #4caf50;
    }
  }
  .pc-all-menus {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    margin: 0 10px;
    padding: 15px 20px;
    border-radius: 4px;
    display: block;
    outline: 0;
    list-style: none;
    font-size: 14px;
    cursor: pointer;
    z-index: 1;
    transition: all 0.2s ease-in-out;
    .item-title {
      margin-left: 14px;
    }
    &:hover {
      color: #4caf50;
    }
  }
  .modulesNav {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    margin: 0 10px;
    padding: 0 !important;
    border-radius: 4px;
    display: block;
    outline: 0;
    list-style: none;
    font-size: 14px;
    cursor: pointer;
    z-index: 1;
    transition: all 0.2s ease-in-out;
    .item-title {
      margin-left: 14px;
    }
    // &:hover {
    //   color: #4caf50;
    // }
    .item {
      padding: 14px;
      &:last-of-type {
        margin-bottom: 0;
      }
      &.active {
        // color: red;
        border-radius: 4px;
      }
    }
  }
  .pc-border {
    margin: -1px auto 29px auto;
    border: solid 0.5px rgba(191, 191, 191, 0.3);
    width: 94%;
  }
  //底部线条
  .pc-border-bottom {
    height: 1px;
    width: 240px;
    // border-bottom: 1px solid #5b5f61;
    margin-left: 10px;
    margin-right: 10px;
    transition: width 0.3s ease;
  }
  .item-title {
    margin-left: 16px;
    white-space: nowrap;
    opacity: 1;
    transition: opacity 0.3s ease;
  }
  .pc-item-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
  }

  // 权限管理图标
  .fa-lock:nth-of-type(1) {
    font-size: 1.65em;
  }
  .ivu-menu-vertical.ivu-menu-light:after {
    display: none;
  }
  .puptip .ivu-tooltip-rel {
    display: flex !important;
  }

  .ivu-menu {
    height: 100%;
  }
  // &:hover {
  //   .pc-sidebar-btn {
  //     transition: all 0.3s;
  //     visibility:visible;
  //     opacity: 1;
  //   }
  // }
  .pc-sidebar-btn {
    position: absolute;
    visibility: hidden;
    opacity: 0;
    display: flex;
    width: 15px;
    height: 80px;
    padding-left: 5px;
    right: -15px;
    top: calc(50% - 70px);
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
    transition-delay: 1s;
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
    // z-index: -1;
  }
}
// //关闭侧边栏
.asideIsClose {
  .ivu-menu-vertical .ivu-menu-item,
  .pc-all-menus,
  .modulesNav,
  .modulesNav .item {
    margin-left: 0;
    border-radius: 0 !important;
    margin-right: 0;
    padding-left: 19px;
  }
  .modulesNav .item.active {
    border-radius: 0;
  }
  .ivu-menu-vertical .ivu-menu-submenu-title {
    margin-left: 0;
    border-radius: 0;
    margin-right: 0;
  }
  .pc-menu-trigger {
    padding-left: 19px;
  }
  .ivu-menu {
    width: 100% !important;
    height: 100%;
  }
  .pc-border-bottom {
    width: 100%;
    margin-left: 0;
  }
  .pc-logo {
    .system-name {
      opacity: 0;
    }
  }
}
//自动生成的文字icon
.word_icon {
  border-radius: 50%;
  display: flex !important;
  justify-content: center;
  align-items: center;
  border: 1px solid;
  line-height: 1;
}
</style>

<style scoped>
.pc-menu-wrapper ::v-deep .ivu-tooltip .ivu-tooltip-rel {
  display: flex;
}
.pc-menu-wrapper ::v-deep .ivu-menu .ivu-menu-item.core-modulesNav {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
}
</style>
